export default __webpack_public_path__ + "static/messages-modal-4f62ac2a84f674ea5e4c6c4cb15bcdd9.jpg";